<script setup lang="ts">
/* eslint-env vue/setup-compiler-macros */
import { ref } from 'vue';

interface Props {
    ariaLabel: string;
    disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    disabled: false,
});

const emit = defineEmits<{
    click: [event: MouseEvent];
}>();

const buttonEl = ref<HTMLButtonElement | null>(null);

function handleClick(event: MouseEvent) {
    if (props.disabled) return;
    emit('click', event);
}

defineExpose({
    buttonEl,
});
</script>

<template>
    <button
        ref="buttonEl"
        v-tooltip-app.top="{ value: props.ariaLabel, class: 'tooltip-app', showDelay: 600 }"
        class="toolbar-icon-button"
        type="button"
        :aria-label="props.ariaLabel"
        :disabled="props.disabled"
        @click="handleClick"
    >
        <slot />
    </button>
</template>

<style lang="scss" scoped>
.toolbar-icon-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 57px;
    height: 46px;
    border: 1px solid $border-gray-color;
    border-radius: 10px;
    background: $white-color;
    color: rgba($black-color, 0.6);
    cursor: pointer;
    transition: border-color 0.15s ease, color 0.15s ease;

    &:hover:not(:disabled) {
        border-color: $toolbar-icon-button-hover-border-color;
        color: $toolbar-icon-button-hover-color;
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.45;
    }
}

.toolbar-icon-button :deep(svg) {
    width: 17px;
    height: 17px;
    flex: none;
}
</style>